module.exports = __webpack_public_path__ + "img/10418934_936867089689079_8217137602160179940_n.d20c81e9.jpg";